// Copy without data bindings
export const cleanCopy = (source) => { 
	return JSON.parse(JSON.stringify(source));
};

// Get variable with dot syntax
export const getWithDot = (obj, selector) => {
	if (typeof selector === 'string' || selector instanceof String) {
		let selectorPath = selector.split('.');
		let first = [...selectorPath].shift();
		if (obj[first]) {
			return selectorPath.reduce((o, k) => o[k], obj);
		}
	}
	return null;
};

export const setWithDot = (object, path, value) => {
    var way = path.replace(/\[/g, '.').replace(/\]/g, '').split('.'),
        last = way.pop();

    way.reduce(function (o, k, i, kk) {
        return o[k] = o[k] || (isFinite(i + 1 in kk ? kk[i + 1] : last) ? [] : {});
	}, object)[last] = value;
	
	return value
}

export const sortItems = (arr, key, asc = false) => {
	return arr.sort((a, b) => (a[key] > b[key]) ? (asc ? 1 : -1) : ((b[key] > a[key]) ? (asc ? -1 : 1) : 0));
};

export const filterItemsByQuery = (items, query, searchableTerms) => {
	if (query && typeof query === 'string') {
		return items.filter((item) => {
			return query.toLowerCase().split(' ').every(v => {
				var res = false;
				searchableTerms.forEach(t => {
					let searchable = getWithDot(item, t);
					if (searchable) {
						res = (!res && searchable.toLowerCase().includes(v)) ? true : res;
					}
				});
				return res;
			})
		})
	} else {
		return items;
	}
};

export const objToFormData = (object) => {
	let data = new FormData();
	Object.entries(object).forEach(d => {
		var [key, value] = d;
		if(typeof value === "boolean") {value = value ? 1 : 0;}
		if (value != null) {
			data.set(key, value);
		}
	});
	return data;
};

export const deepFind = (items, key, value, childrenKey) => {
	var found = false
	items.find(i => {
		if (i[key] == value) {
			found = i
			return true;
		}
		else if(!!i[childrenKey]) {
			found = deepFind(i[childrenKey], key, value, childrenKey)
		}
	});
	return found;
}